import Vue from "vue";
import Router from "vue-router";

Vue.use(Router)

/*
const originPush = Router.prototype.push;
Router.prototype.push = function push(location){
  return originPush.call(this, location).catch(err => err);
}
  */


import Login from "@/pages/login";
import ProfileForm from "@/pages/xiaoyou/mycenter/profile-form";
import ProfileDetail from "@/pages/xiaoyou/mycenter/profile-detail";

const router = new Router({  
  base: process.env.VUE_APP_CONTEXT_PATH,
  mode: 'history', // 去掉url中的#
  routes: [
    {
      path: '/',      
      name: 'Home',
      component: ProfileDetail,
    },
    
    {
      path: '/login',
      name: 'Login',      
      component: Login,
    },
    {
      path: '/profile-form',
      name: 'ProfileForm',
      component: ProfileForm,
    },
    {
      path: '/myprofile',
      name: 'MyProfile',
      component: ProfileDetail,
    },
  ]
});

// 路由跳转前
router.beforeEach((to, from, next) => {
  // 可用于拦截导航并执行一些操作，例如验证用户身份、权限控制等。

  if(to.meta && to.meta.title){
    document.title = to.meta.title;
  }
  next();
});

// 路由跳转后
router.afterEach((to, from) => {
  window.scrollTo(0, 0); // 每次路由改变滚动条都回到顶部
});

export default router;
